import React, { useState, useEffect } from "react";

const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.vivashri";

function MobileAppPrompt() {
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    // Check if mobile device (Android or iOS or screen width <= 768px)
    const ua = navigator.userAgent || "";
    const isBotOrLighthouse = /Lighthouse|HeadlessChrome|Chrome-Lighthouse|PageSpeed/i.test(ua);
    if (isBotOrLighthouse) return;

    const isMobileUserAgent = /Android|iPhone|iPad|iPod/i.test(ua);
    const isMobileScreen = window.innerWidth <= 768;
    const isMobile = isMobileUserAgent || isMobileScreen;

    if (!isMobile) return;

    // Check if user already dismissed or made choice in this session
    const isDismissed = sessionStorage.getItem("vivashri_app_prompt_dismissed");
    if (isDismissed === "1") return;

    // Show prompt after 12 seconds
    const timer = setTimeout(() => {
      setShowPrompt(true);
    }, 12000);

    return () => clearTimeout(timer);
  }, []);

  const handleContinueInApp = () => {
    const isAndroid = /Android/i.test(navigator.userAgent || "");
    const { host, pathname, search, hash } = window.location;

    if (isAndroid) {
      const intentUrl = `intent://${host}${pathname}${search}${hash}#Intent;scheme=https;package=com.vivashri;S.browser_fallback_url=${encodeURIComponent(
        PLAY_STORE_URL
      )};end`;
      window.location.href = intentUrl;
    } else {
      // Fallback / iOS -> Open Play Store / App Link
      window.open(PLAY_STORE_URL, "_blank");
    }

    setShowPrompt(false);
  };

  const handleContinueOnWeb = () => {
    // Remember choice for current session
    sessionStorage.setItem("vivashri_app_prompt_dismissed", "1");
    setShowPrompt(false);
  };

  if (!showPrompt) return null;

  return (
    <div style={styles.overlay} onClick={handleContinueOnWeb}>
      <style>{`
        @keyframes vsFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes vsSlideUp {
          from { transform: translateY(100%); }
          to { transform: translateY(0); }
        }
      `}</style>
      <div style={styles.sheet} onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <button
          style={styles.closeBtn}
          onClick={handleContinueOnWeb}
          aria-label="Close"
        >
          ✕
        </button>

        {/* Drag handle */}
        <div style={styles.dragHandle} />

        {/* Header with App Icon */}
        <div style={styles.header}>
          <img
            src="/assets/img/android-chrome-192x192.png"
            alt="Vivashri App"
            style={styles.appIcon}
            onError={(e) => {
              e.target.src = "/assets/img/logo-light.png";
            }}
          />
          <div style={styles.appInfo}>
            <h3 style={styles.appName}>Vivashri Matrimony</h3>
            <p style={styles.appSubtitle}>Official Mobile App</p>

          </div>
        </div>

        {/* Feature Highlights */}
        <div style={styles.features}>
          <div style={styles.featureItem}>
            <span style={styles.featureCheck}>✓</span> Instant Chat & Notifications
          </div>
          <div style={styles.featureItem}>
            <span style={styles.featureCheck}>✓</span> Faster & Smoother Matchmaking
          </div>
          <div style={styles.featureItem}>
            <span style={styles.featureCheck}>✓</span> 100% Privacy & Security
          </div>
        </div>

        {/* Action Buttons */}
        <div style={styles.buttonGroup}>
          <button style={styles.primaryBtn} onClick={handleContinueInApp}>
            <i className="fab fa-google-play" style={{ marginRight: 8 }}></i>
            Continue in App
          </button>

          <button style={styles.secondaryBtn} onClick={handleContinueOnWeb}>
            Continue on Web
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.65)",
    backdropFilter: "blur(4px)",
    WebkitBackdropFilter: "blur(4px)",
    zIndex: 999999,
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    animation: "vsFadeIn 0.3s ease-out",
  },
  sheet: {
    backgroundColor: "#ffffff",
    width: "100%",
    maxWidth: "480px",
    borderTopLeftRadius: "24px",
    borderTopRightRadius: "24px",
    padding: "24px 20px 28px 20px",
    boxShadow: "0 -10px 30px rgba(0, 0, 0, 0.25)",
    position: "relative",
    boxSizing: "border-box",
    animation: "vsSlideUp 0.35s cubic-bezier(0.16, 1, 0.3, 1)",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  },
  dragHandle: {
    width: "40px",
    height: "4px",
    backgroundColor: "#e0e0e0",
    borderRadius: "2px",
    margin: "0 auto 16px auto",
  },
  closeBtn: {
    position: "absolute",
    top: "16px",
    right: "16px",
    background: "#f0f0f0",
    border: "none",
    borderRadius: "50%",
    width: "32px",
    height: "32px",
    fontSize: "14px",
    color: "#666",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    marginBottom: "16px",
  },
  appIcon: {
    width: "64px",
    height: "64px",
    borderRadius: "16px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
    objectFit: "cover",
    backgroundColor: "#fff",
  },
  appInfo: {
    flex: 1,
  },
  appName: {
    margin: 0,
    fontSize: "18px",
    fontWeight: "700",
    color: "#222",
    lineHeight: "1.3",
  },
  appSubtitle: {
    margin: "2px 0 4px 0",
    fontSize: "13px",
    color: "#777",
  },
  ratingRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  stars: {
    color: "#f59e0b",
    fontSize: "13px",
    letterSpacing: "1px",
  },
  ratingText: {
    fontSize: "12px",
    color: "#555",
    fontWeight: "500",
  },
  features: {
    backgroundColor: "#fbf2f6",
    borderRadius: "12px",
    padding: "12px 14px",
    marginBottom: "20px",
    border: "1px solid #f6dbe6",
  },
  featureItem: {
    fontSize: "13px",
    color: "#444",
    lineHeight: "1.7",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontWeight: "500",
  },
  featureCheck: {
    color: "#e83a73",
    fontWeight: "bold",
    fontSize: "14px",
  },
  buttonGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  primaryBtn: {
    backgroundColor: "#e83a73",
    backgroundImage: "linear-gradient(135deg, #e83a73 0%, #c2185b 100%)",
    color: "#ffffff",
    border: "none",
    borderRadius: "12px",
    padding: "14px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 4px 14px rgba(232, 58, 115, 0.35)",
    transition: "transform 0.15s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
  },
  secondaryBtn: {
    backgroundColor: "transparent",
    color: "#666666",
    border: "1px solid #ddd",
    borderRadius: "12px",
    padding: "12px",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    textAlign: "center",
    transition: "background 0.15s ease",
  },
};

export default MobileAppPrompt;
